// extracted by mini-css-extract-plugin
module.exports = {"card":"CompanyDetails_card__acbDo","title":"CompanyDetails_title__3VQpc","table":"CompanyDetails_table__XXrdg"};